import { Grid } from '@mui/material';
import PageHeader from 'components/PageHeader';
import wrapPage from 'components/atoms/wrapPage/wrapPage';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MarkdownRenderer from '../MarkdownRenderer';
import markdownContent from '../PRIVACYPOLICY.md';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const outsideOfApp = !location.state || location.state?.fromExternalLink;

  return (
    <Grid container direction="column" sx={{ my: 4, px: 6 }}>
      <Grid item>
        <PageHeader
          pageTitle={'Privacy Policy'}
          onBackClick={() => {
            if (outsideOfApp) {
              navigate('/');
            } else {
              navigate(-1);
            }
          }}
        />
      </Grid>
      <Grid item>
        <MarkdownRenderer content={markdownContent} />
      </Grid>
    </Grid>
  );
};

export default wrapPage(PrivacyPolicy, {}, false);
